import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=4c5c0d08"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"
import style0 from "./Resume.vue?vue&type=style&index=0&id=4c5c0d08&prod&lang=stylus"
import style1 from "./Resume.vue?vue&type=style&index=1&id=4c5c0d08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports